module.exports = __webpack_public_path__ + "img/logo.91861a81.png";